import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
  </>,
  'ChevronLeft',
)
